import { render, staticRenderFns } from "./MobileChat.vue?vue&type=template&id=beee9e98&scoped=true"
import script from "./MobileChat.vue?vue&type=script&lang=js"
export * from "./MobileChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beee9e98",
  null
  
)

export default component.exports